module.exports = __webpack_public_path__ + "img/bindChat_d.aab5ec92.png";